import React, { useEffect, useState } from 'react'
import useDropdowns from '../../hooks/api/useDropdowns'
import { authedAxios } from '../../utils'

import { Box, Button, IconButton, MenuItem, TextField } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'

import { useScreenSize } from '../../hooks/useIsMobile'
import FilterSelection from './FilterSelection'
import ColumnSelection from './ColumnSelection'

const ColumnsAndFilters = ({
  filters,
  setFilters,
  data,
  customFields,
  selectableColumns,
  handleColumnsChange,
  selectedColumnKeys,
  setSelectedColumnKeys,
  views,
  setSelectedView,
  selectedView,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  const { dropdownsSummary, ..._dropdownsSummary } = useDropdowns()

  const nextSteps = dropdownsSummary.find((ds) => ds.key === 'nextStep')

  const [types, setTypes] = useState(null)
  const [typesLoading, setTypesLoading] = useState(true)

  const handleKeydown = (evt) => {
    if (evt.key === 'Escape') setIsOpen(false)
  }

  useEffect(() => {
    if (isOpen) document.addEventListener('keydown', handleKeydown)
    return () => document.removeEventListener('keydown', handleKeydown)
  }, [isOpen])

  const getAllTypes = () => {
    if (types) return
    return authedAxios
      .get('/api/customer/types/all')
      .then((res) => {
        setTypes(res.data.types)
        setTypesLoading(false)
        return res
      })
      .catch((e) => {
        // TODO
        setTypesLoading(false)
      })
  }

  useEffect(() => {
    getAllTypes()
  }, [])

  const { windowWidth } = useScreenSize()

  const isLoading = _dropdownsSummary.isLoading || typesLoading

  if (isLoading) return null

  const width = Math.min(392, windowWidth)

  return (
    <Box
      sx={{
        zIndex: isOpen || isAnimating ? 2 : null,
        width: `calc(${width * 2}px - 48px)`,
        left: isOpen ? '-24px' : `-${width * 2 + 24}px`,
        position: 'absolute',
        top: '-12px',
        height: 'calc(100% - 30px)',
        boxShadow: ' 0 7px 9px 0px rgb(0 0 0 / 40%)',
        backgroundColor: 'white',
        transition: 'left 0.5s',
        p: 3,
        zIndex: 3,
      }}
    >
      {!isOpen && !isAnimating && (
        <Button
          sx={{
            backgroundColor: 'white',
            position: 'absolute',
            right: '-104px',
            top: 'calc(50% - 60px)',
            transform: 'rotate(-90deg)',
          }}
          onClick={() => setIsOpen(true)}
          variant={'outlined'}
        >
          Columns & Filters
        </Button>
      )}

      <Box sx={{ height: '100%', display: 'flex' }}>
        <Box sx={{ height: '100%', width: '50%' }}>
          <TextField
            select
            label='Pre-saved views'
            fullWidth
            sx={{ mt: 4, mb: 1 }}
            value={selectedView}
            onChange={(e) => setSelectedView(e.target.value)}
          >
            {views.map((v, i) => (
              <MenuItem key={i} value={i}>
                {i === 0 ? 'Default' : v.name}
              </MenuItem>
            ))}
          </TextField>
          <IconButton
            sx={{ position: 'absolute', right: '8px', top: '8px' }}
            onClick={() => {
              setIsOpen(false)
              setIsAnimating(true)
              setTimeout(() => {
                setIsAnimating(false)
              }, 500)
            }}
          >
            <ChevronLeft />
          </IconButton>
          <Box sx={{ height: 'calc(100% - 116px)' }}>
            <FilterSelection
              filters={filters}
              setFilters={setFilters}
              data={data}
              customFields={customFields}
              nextSteps={nextSteps}
              types={types}
            />
          </Box>
        </Box>
        <Box sx={{ height: '100%', width: '50%', ml: 4 }}>
          <ColumnSelection
            selectableColumns={selectableColumns}
            handleColumnsChange={handleColumnsChange}
            selectedColumnKeys={selectedColumnKeys}
            setSelectedColumnKeys={setSelectedColumnKeys}
            customFields={customFields}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default ColumnsAndFilters
